import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from '../ui/FadeIn';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const reviews = [{
  name: 'María José Rodríguez',
  age: 58,
  city: 'Montevideo',
  photo: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=120&h=120&fit=crop&crop=face&q=80',
  stars: 5,
  text: 'Llevaba años con dolor de articulaciones y probé de todo. Con las recetas antiinflamatorias del libro, en dos semanas ya sentí una mejora enorme. ¡Lo recomiendo a todas mis amigas!'
}, {
  name: 'Carlos Martínez',
  age: 63,
  city: 'Salto',
  photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&h=120&fit=crop&crop=face&q=80',
  stars: 5,
  text: 'Mi esposa me preparó el tónico para dormir y fue increíble. Ahora duermo de corrido toda la noche. Hacía años que no descansaba así.'
}, {
  name: 'Lucía Fernández',
  age: 45,
  city: 'Punta del Este',
  photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&h=120&fit=crop&crop=face&q=80',
  stars: 4,
  text: 'Las recetas para la digestión me cambiaron la vida. Ya no tengo esa hinchazón después de comer. Todo con ingredientes que tenía en casa.'
}, {
  name: 'Roberto Pereira',
  age: 71,
  city: 'Colonia',
  photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&h=120&fit=crop&crop=face&q=80',
  stars: 5,
  text: 'A mi edad uno ya no confía en cualquier cosa, pero estos remedios son los mismos que usaba mi madre. Volví a sentirme con energía.'
}, {
  name: 'Ana Paula Gómez',
  age: 39,
  city: 'Maldonado',
  photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=120&h=120&fit=crop&crop=face&q=80',
  stars: 5,
  text: 'Compré el recetario para mi mamá y terminé usándolo yo también. Los tés para la ansiedad son buenísimos. Muy completo.'
}, {
  name: 'Graciela Suárez',
  age: 66,
  city: 'Rivera',
  photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=120&h=120&fit=crop&crop=face&q=80',
  stars: 5,
  text: 'El plan detox de 3 días fue una revelación. Me sentí liviana y con mucha más claridad mental. Las instrucciones son super claras.'
}];
export function ReviewsSection() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1);
  const next = useCallback(() => {
    setDirection(1);
    setCurrent(prev => (prev + 1) % reviews.length);
  }, []);
  const prev = useCallback(() => {
    setDirection(-1);
    setCurrent(prev => (prev - 1 + reviews.length) % reviews.length);
  }, []);
  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);
  const review = reviews[current];
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 200 : -200,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -200 : 200,
      opacity: 0
    })
  };
  return <section className="bg-ancestral-cream py-12 md:py-16 text-ancestral-dark" data-id="element-364">
      <div className="container mx-auto px-4" data-id="element-365">
        <div className="max-w-2xl mx-auto" data-id="element-366">
          {/* Header */}
          <FadeIn data-id="element-367">
            <div className="text-center mb-8" data-id="element-368">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-ancestral-green mb-3" data-id="element-369">
                Lo Que Dicen Nuestros Lectores
              </h2>

              {/* Stats row */}
              <div className="flex items-center justify-center gap-5 flex-wrap" data-id="element-370">
                {/* Stars */}
                <div className="flex items-center gap-1.5" data-id="element-371">
                  <div className="flex gap-0.5" data-id="element-372">
                    {[1, 2, 3, 4].map(i => <svg key={i} viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 text-ancestral-gold" data-id="element-373">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-374" />
                      </svg>)}
                    <svg viewBox="0 0 20 20" className="w-4 h-4" data-id="element-375">
                      <defs data-id="element-376">
                        <linearGradient id="reviewHalfStar" data-id="element-377">
                          <stop offset="50%" stopColor="#C9A84C" data-id="element-378" />
                          <stop offset="50%" stopColor="#C9A84C" stopOpacity="0.25" data-id="element-379" />
                        </linearGradient>
                      </defs>
                      <path fill="url(#reviewHalfStar)" d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-380" />
                    </svg>
                  </div>
                  <span className="text-sm font-bold text-ancestral-dark" data-id="element-381">
                    4.5/5
                  </span>
                </div>

                <span className="text-ancestral-dark/20" data-id="element-382">|</span>

                {/* Downloads */}
                <div className="flex items-center gap-1.5" data-id="element-383">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-ancestral-gold" data-id="element-384">
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" data-id="element-385" />
                    <polyline points="7 10 12 15 17 10" data-id="element-386" />
                    <line x1="12" y1="15" x2="12" y2="3" data-id="element-387" />
                  </svg>
                  <span className="text-sm font-bold text-ancestral-dark" data-id="element-388">
                    +3,454 descargas
                  </span>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* Review carousel */}
          <FadeIn delay={0.15} data-id="element-389">
            <div className="relative" data-id="element-390">
              <div className="bg-white border border-gray-200 rounded-2xl shadow-md p-6 md:p-8 min-h-[200px] overflow-hidden" data-id="element-391">
                <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-392">
                  <motion.div key={current} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
                  duration: 0.35,
                  ease: 'easeInOut'
                }} data-id="element-393">
                    {/* Person */}
                    <div className="flex items-center gap-4 mb-4" data-id="element-394">
                      <div className="w-12 h-12 rounded-full bg-ancestral-green/10 border-2 border-ancestral-gold/30 flex items-center justify-center flex-shrink-0" data-id="element-395">
                        <span className="text-lg font-bold text-ancestral-green" data-id="element-396">
                          {review.name.split(' ').map(n => n[0]).slice(0, 2).join('')}
                        </span>
                      </div>
                      <div data-id="element-397">
                        <p className="font-bold text-ancestral-dark" data-id="element-398">
                          {review.name}
                        </p>
                        <p className="text-xs text-ancestral-dark/50" data-id="element-399">
                          {review.age} años · {review.city}
                        </p>
                      </div>
                    </div>

                    {/* Stars */}
                    <div className="flex gap-0.5 mb-3" data-id="element-400">
                      {Array.from({
                      length: review.stars
                    }).map((_, i) => <svg key={i} viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 text-ancestral-gold" data-id="element-401">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-402" />
                        </svg>)}
                    </div>

                    {/* Text */}
                    <p className="text-ancestral-dark/70 leading-relaxed text-sm md:text-base italic" data-id="element-403">
                      "{review.text}"
                    </p>
                  </motion.div>
                </AnimatePresence>
              </div>

              {/* Navigation arrows */}
              <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 md:-translate-x-5 bg-white shadow-md border border-gray-200 rounded-full p-2 hover:bg-gray-50 transition-colors z-10" aria-label="Anterior" data-id="element-404">
                <ChevronLeftIcon className="w-4 h-4 text-ancestral-green" data-id="element-405" />
              </button>
              <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 md:translate-x-5 bg-white shadow-md border border-gray-200 rounded-full p-2 hover:bg-gray-50 transition-colors z-10" aria-label="Siguiente" data-id="element-406">
                <ChevronRightIcon className="w-4 h-4 text-ancestral-green" data-id="element-407" />
              </button>
            </div>

            {/* Dots */}
            <div className="flex justify-center gap-1.5 mt-5" data-id="element-408">
              {reviews.map((_, idx) => <button key={idx} onClick={() => {
              setDirection(idx > current ? 1 : -1);
              setCurrent(idx);
            }} className={`rounded-full transition-all duration-300 ${idx === current ? 'w-6 h-2 bg-ancestral-green' : 'w-2 h-2 bg-ancestral-green/20 hover:bg-ancestral-green/40'}`} aria-label={`Reseña de ${reviews[idx].name}`} data-id="element-409" />)}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}